export const noSelectedInvoice = (position) => {
	return {
		id: "",
		reference: "",
		number: "",
		type: "",
		class: "",
		date: "",
		currency: "",
		sender_id: "",
		sender_name: "",
		establishment_id: "",
		establishment_name: "",
		receptor_id: "",
		receptor_name: "",
		total: "",
		taxes: [],
		canceled: "",
		url: "",
		items: [],
		tax_authority_specifications: {
			frases: [],
		},
		registration_date_aro: "",
		accounting_specifications: {
			[position]: {
				state: "",
				description: "",
				diary: "",
				expense_type: "",
				accounting_date: "",
			},
		},
	};
};